import ExcelJS from "exceljs"
import { saveAs } from "file-saver"
import moment from "moment"
// import JsBarcode from "jsbarcode"

// const generateBarcodeBase64 = (value: string) => {
//   const canvas = document.createElement("canvas")
//   JsBarcode(canvas, value, {
//     displayValue: false,
//     width: 1,
//     height: 30,
//     margin: 0,
//   })
//   return canvas.toDataURL("image/png")
// }

export async function exportExcelAnalyseSalesPeriode(data: any[]) {
  const workbook = new ExcelJS.Workbook()
  const worksheet = workbook.addWorksheet("Invoice List")

  /* ================= HEADER ================= */
  const headers = [
    "NO", "DATE", "INVOICE ID", "CUSTOMER", "LOCATION",
    "ITEM CODE", "DESCRIPTION", "QTY", "UNIT",
    "PRICE", "EXT. AMOUNT", "TAX", "JOB",
    "", "COGM", "COGM AMOUNT", "SALES PROFIT"
  ]

  worksheet.addRow(headers)

  worksheet.getRow(1).eachCell((cell) => {
    cell.font = { bold: true, color: { argb: "FFFFFFFF" } }
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF000000" }
    }
    cell.alignment = { vertical: "middle", horizontal: "center" }
    cell.border = { top:{style:"thin"},left:{style:"thin"},bottom:{style:"thin"},right:{style:"thin"} }
  })

  worksheet.columns = [
    { width: 6 }, { width: 14 }, { width: 18 }, { width: 18 }, { width: 14 },
    { width: 14 }, { width: 30 }, { width: 8 }, { width: 10 },
    { width: 14 }, { width: 16 }, { width: 16 }, { width: 18 },
    { width: 3 }, { width: 14 }, { width: 18 }, { width: 16 }
  ]

  let rowNumber = 1

  /* ================= DATA ================= */
  data.forEach(group => {
    /* ===== DATE ROW ===== */
    const dateRow = worksheet.addRow([
      moment(group.transaction_date).format("DD/MM/YYYY")
    ])
    worksheet.mergeCells(`A${dateRow.number}:M${dateRow.number}`)
    worksheet.mergeCells(`O${dateRow.number}:Q${dateRow.number}`)

    dateRow.font = { bold: true }
    dateRow.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFD9DCE1" }
    }

    group.invoices.forEach((invoice: any) => {
      /* ===== INVOICE ROW ===== */
      const invRow = worksheet.addRow([invoice.trx_code])
      worksheet.mergeCells(`A${invRow.number}:M${invRow.number}`)
      worksheet.mergeCells(`O${invRow.number}:Q${invRow.number}`)

      invRow.font = { bold: true }
      invRow.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFF2F2F2" }
      }

      /* ===== ITEMS ===== */
      invoice.items.forEach((item: any) => {
        // const base64 = generateBarcodeBase64(item.product_barcode)
        // const imageId = workbook.addImage({ base64, extension: "png" })

        worksheet.addRow([
          rowNumber++,
          moment(item.transaction_date).format("DD/MM/YYYY"),
          item.trx_code,
          item.customer_name,
          item.location_name,
          item.product_barcode,
          item.product_name,
          Number(item.quantity_invoice),
          item.unit_sell_measure_name,
          Number(item.price_invoice),
          Number(item.total),
          `${item.tax_name} (${item.tax_rate}%)`,
          item.project_name,
          "",
          Number(item.cogm),
          Number(item.cogm_amount),
          Number(item.sale_profit)
        ])
        // row.height = 20
        // worksheet.addImage(imageId, {
        //   tl: { col: 5, row: row.number - 1 },
        //   ext: { width: 100, height: 30 },
        // })
      })
    })

    /* ===== TOTAL PER DATE ===== */
    const totalRow = worksheet.addRow([
      "", "", "", "", "", "",
      `Total : ${moment(group.transaction_date).format("DD/MM/YYYY")}`,
      group.total_quantity,
      "", "", group.total_amount,
      "", "", "", "",
      group.total_cogm_amount,
      group.total_sale_profit
    ])

    worksheet.mergeCells(`A${totalRow.number}:F${totalRow.number}`)

    totalRow.font = { bold: true }
    totalRow.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFEDEDED" }
    }
  })

  /* ================= FORMAT NUMBER ================= */
  worksheet.eachRow((row, rowNumber) => {
    if (rowNumber > 1) {
      row.getCell(8).numFmt = "#,##0"
      row.getCell(10).numFmt = "#,##0"
      row.getCell(11).numFmt = "#,##0"
      row.getCell(15).numFmt = "#,##0"
      row.getCell(16).numFmt = "#,##0"
      row.getCell(17).numFmt = "#,##0"
    }
  })

  /* ================= EXPORT ================= */
  const buffer = await workbook.xlsx.writeBuffer()
  saveAs(
    new Blob([buffer]),
    `Invoice_List_${moment().format("YYYYMMDD_HHmmss")}.xlsx`
  )
}
